// test2088
(2088 && 0);
